import { account as accountApi } from '@/backend/api'
import Vue from 'vue'
import router from '@/router'

const stateAbstract = {
  retrieveLoader: false,
  createLoader: false,
  destroyLoader: false
}

const setQueryTestMode = (query = {}) => {
  return router.currentRoute.path.startsWith('/test') ? { ...query, test: true } : query
}

const actionsAbstract = {
  GET: ({ commit }, { resource, query = {}, loader = true }) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_RETRIEVE_LOADER')
      }
      accountApi.get(resource, setQueryTestMode(query))
        .then(response => {
        commit('SET_LIST', { response: response, resource: resource })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (loader) {
          commit('TOGGLE_RETRIEVE_LOADER')
        }
      })
    })
  },
  LIST: ({ commit }, { resource, query, loader = true, responseType, headers = {} }) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_RETRIEVE_LOADER')
      }
      accountApi.list(resource, setQueryTestMode(query), responseType, headers)
      .then(response => {
        commit('SET_LIST', { response: response, resource: resource })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (loader) {
          commit('TOGGLE_RETRIEVE_LOADER')
        }
      })
    })
  },
  RETRIEVE: ({ commit }, { resource, id, detail, query, setDetail = true, loader = true, headers = {}, responseType = '' }) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_RETRIEVE_LOADER')
      }
      accountApi.retrieve(resource, id, detail, setQueryTestMode(query), headers, responseType)
      .then(response => {
        if (setDetail) {
          commit('SET_DETAIL', {
            response: response,
            resource: resource,
            loader: loader
          })
        }
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (loader) {
          commit('TOGGLE_RETRIEVE_LOADER')
        }
      })
    })
  },
  CREATE: ({ commit }, { resource, payload, detail, id, headers, commitInstance = true, query = {}, isNotTest = false }) => {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_CREATE_LOADER')
      accountApi.create(resource, payload, detail, id, headers, setQueryTestMode(query), isNotTest)
      .then(response => {
        if (commitInstance) {
          commit('SET_DETAIL', { response: response, resource: resource })
        }
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        commit('TOGGLE_CREATE_LOADER')
      })
    })
  },
  UPDATE: ({ commit }, { resource, id, payload, headers, detail = '' }) => {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_CREATE_LOADER')
      accountApi.update(resource, id, payload, headers)
      .then(response => {
        commit('SET_DETAIL', { response: response, resource: resource, detail })
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        commit('TOGGLE_CREATE_LOADER')
      })
    })
  },
  DESTROY: ({ commit }, { resource, id, query, loader = true, commitInstance = true, detail = ''}) => {
    return new Promise((resolve, reject) => {
      if (loader) {
        commit('TOGGLE_DESTROY_LOADER')
      }
      accountApi.destroy(resource, id, setQueryTestMode(query), detail)
      .then(() => {
        if (commitInstance) {
          commit('SET_DELETE', { resource: resource, id: id })
        }
        resolve()
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        if (loader) {
          commit('TOGGLE_DESTROY_LOADER')
        }
      })
    })
  },
  DOWNLOAD: ({ commit }, { resource, payload, query = {} }) => {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_CREATE_LOADER')
      accountApi.download(resource, payload, null, null, {}, setQueryTestMode(query))
      .then(response => {
        // if (commitInstance) {
        //   commit('SET_DETAIL', { response: response, resource: resource })
        // }
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
      .finally(() => {
        commit('TOGGLE_CREATE_LOADER')
      })
    })
  }
}

const mutationsAbstract = {
  SET_LIST: (state, { response, resource }) => {
    let url = resource.includes('expand') ? resource.split('/')[0] : resource.split('/').pop()
    if (url.search(/rec-docs/) !== -1) url = url.replace(/-/g, '')

    state[`${url}List`] = response?.data?.results ?? response?.data ?? response
    state[`${url}Count`] = response?.data?.next ? !!response?.data?.next : response?.data?.count ?? 0
  },
  SET_DETAIL: (state, { response, resource, loader }) => {
    const r = resource.split('/').pop()
    const listName = r + 'List'
    let detailName = r + 'Detail'
    if (detailName.search(/rec-docs/) !== -1) detailName = detailName.replace(/-/g, '')

    if (state[detailName]) {
      state[detailName] = response.data
    }

    if (state[listName]) {
      const method = response?.config?.method

      if (method === 'post') {
        state[listName].push(response.data)
      }

      if (method === 'patch') {
        const index = state[listName].findIndex((item) => item.id === response.data.id)
        Vue.set(state[listName], index, response.data)
      }
    }
  },
  SET_DELETE: (state, { resource, id }) => {
    const r = resource.split('/').pop()
    const index = state[`${r}List`].findIndex(d => d.id === id)
    state[`${r}List`].splice(index, 1)
  },
  SET_LOADER: (state, action) => {
    state[`${action}Loader`] = !state[`${action}Loader`]
  },
  TOGGLE_CREATE_LOADER: (state) => {
    state.createLoader = !state.createLoader
  },
  TOGGLE_RETRIEVE_LOADER: (state) => {
    state.retrieveLoader = !state.retrieveLoader
  },
  TOGGLE_DESTROY_LOADER: (state) => {
    state.destroyLoader = !state.destroyLoader
  }
}

export { stateAbstract, actionsAbstract, mutationsAbstract }